export default __webpack_public_path__ + "static/media/AG13.dae9f10b.mp3";